module.exports = __webpack_public_path__ + "static/media/default.903d98d0.svg";